


import React, { useState, useEffect } from 'react';
import Parse from 'parse';

import useUIPresentationMode from './useUIPresentationMode.js';

import '../styles/phcolours.css';


const ShareModal = ({ isOpen, onClose }) => {

    const user = Parse.User.current();
    const [yourName, setYourName] = useState('');
    const [yourEmail, setYourEmail] = useState('');
    const [canSend, setCanSend] = useState(false);

    const guestIdentifiers = ['guest@planhub.app'];
    const userIsGuest = user && guestIdentifiers.includes(user.get('username'));


    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);


    useEffect(() => {

        if (!isOpen) return;

        const validEmail = /\S+@\S+\.\S+/.test(yourEmail);
        const requiredFieldsFilled = yourName.trim() && validEmail;

        setCanSend(!!requiredFieldsFilled);

    }, [isOpen, yourName, yourEmail]);


    // Reset our check on closing.
    useEffect(() => {
        if (!isOpen) {
            setYourName('');
            setYourEmail('');
            setCanSend(false);
        }
    }, [isOpen]);


    const handleSend = async () => {

        const enquiryUrl = window.location.href;
        const fullName = yourName.trim();

        /*
        console.log("📨 Enquiry incoming", {
            fullName,
            yourEmail,
            enquiryUrl
        });
        */

        try {
            const params = {
                fullName,
                email: yourEmail,
                enquiryUrl
            };

            await Parse.Cloud.run('sendEnquiryEmailFromWebApp', params);
            onClose();
        } catch (err) {
            console.error(err);
            alert('Something went wrong sending your enquiry.');
        }
    };


    // Scale this mofo depending on screen size.
    const { presentationModeSize } = useUIPresentationMode(); // Get the clean responsive size

    const [scaleFactor, setScaleFactor] = useState(0.9);

    useEffect(() => {
        if (presentationModeSize === 1 || presentationModeSize === 2) {  // Big!
            setScaleFactor(0.9);
        }
        if (presentationModeSize === 3) {  // Not as big.
            setScaleFactor(0.9);
        }
        if (presentationModeSize === 4 || presentationModeSize === 5) {  // Little!
            setScaleFactor(0.8);
        }
    }, [presentationModeSize]);


    if (!isOpen) return null;


    return (
        <div className="ui-share-modal" style={styles.overlay} onClick={onClose}>
            <div
                style={{
                    ...styles.modal,
                    transform: `translate(-50%, -50%) scale(${scaleFactor})`
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2 style={styles.headerLabel}>Need an Estimate?</h2>
                <p style={{ fontSize: '14px', color: 'var(--phblue)', marginTop: '5px', marginBottom: '20px' }}>
                    Send your plan through to us and we’ll provide feedback on cost — and anything else you would like to know — all specific to your site.
                </p>

                <div style={{ marginTop: '10px' }}>
                    {userIsGuest && (
                        <>
                            <label style={styles.inputLabel}>Your name:</label>
                            <input
                                type="text"
                                onChange={(e) => setYourName(e.target.value)}
                                style={styles.inputField}
                            />

                            <label style={styles.inputLabel}>Your email:</label>
                            <input
                                type="email"
                                name="recipientEmailCustom"
                                autoComplete="off"
                                data-lpignore="true"
                                onChange={(e) => setYourEmail(e.target.value)}
                                style={styles.inputField}
                            />
                        </>
                    )}
                </div>

                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={onClose} style={styles.cancel}>Cancel</button>
                    <button
                        onClick={handleSend}
                        disabled={!canSend}
                        style={{
                            ...styles.send,
                            backgroundColor: canSend ? 'var(--phgreenwashed)' : '#eee',
                            color: canSend ? 'var(--phgreenfont)' : 'var(--phgrey)',
                            cursor: canSend ? 'pointer' : 'not-allowed'
                        }}
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};



const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        overflow: 'hidden',
        zIndex: '10001',
    },
    modal: {
        background: 'var(--phbluesuperwashedbackground)',
        borderRadius: '10px',
        padding: '30px',
        width: '400px',
        boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transformOrigin: 'center',
    },
    headerLabel: {
        fontSize: '20px',
        fontWeight: 700,
        color: 'var(--phblue)',
        padding: '0px 10px 10px 0px'
    },
    inputLabel: {
        display: 'block',
        fontSize: '13px',
        fontWeight: 600,
        color: 'var(--phblue)',
        marginTop: '25px',
        marginBottom: '6px',
    },
    inputField: {
        lineHeight: '20px',
        height: '40px',
        width: '100%',
        padding: '8px 10px',
        fontSize: '14px',
        border: '1.5px solid var(--phblue)',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: 'var(--phblue)',
        outline: 'none',
    },
    cancel: {
        marginRight: '10px',
        padding: '10px 20px',
        backgroundColor: '#eee',
        border: 'none',
        borderRadius: '7px',
        cursor: 'pointer'
    },
    send: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '7px',
        backgroundColor: '#eee',
    }
};



export default ShareModal;



